import {Alert, Button, Divider, message} from "antd";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {AuthFormWrapper} from "../../../layouts/auth-form-wrapper";
import {RootState} from "../../../redux/store";
import {AnalyticsEvent} from "../../../utils/analytics";
import {LoginForm} from "./login-form";
import {StyledAuthTitleCenterAlign} from "../../../layouts/auth-form-wrapper/auth-form-wrapper.style";
import {ErrorBoundary} from "react-error-boundary";
import {GoogleOAuthButton} from "../../../components/google-button/google-button";

const LoginPage = () => {
  const {isError: isErrorUserProfile, message: userProfileMessage} = useSelector(
    (state: RootState) => state.userProfile
  );

  useEffect(() => {
    if (
      isErrorUserProfile &&
      userProfileMessage === "Your session has expired! Please, login and try again!"
    ) {
      message.warning(userProfileMessage);
    }
  }, [isErrorUserProfile, userProfileMessage]);

  return (
    <AuthFormWrapper>
      <StyledAuthTitleCenterAlign>
        <div>
          <h2 className="form-main-heading">Log in as a coach</h2>
        </div>
      </StyledAuthTitleCenterAlign>
      <p className="login-option">Manage your offerings, customers and earnings</p>
      <LoginForm />
      <p className="login-option">
        Don't have an account yet?{" "}
        <Link
          style={{textDecoration: "underline", fontWeight: 600}}
          onClick={() =>
            AnalyticsEvent("Login page", `Clicked on Create new account link`)
          }
          to="/auth/register"
        >
          Create a free account
        </Link>
      </p>
      <div>
        <Divider plain style={{margin: 0}}>
          <span style={{color: "#8C8C8C", fontWeight: 600, fontSize: "1.4rem"}}>Or</span>
        </Divider>
      </div>
      <StyledAuthTitleCenterAlign>
        <div>
          <ErrorBoundary
            FallbackComponent={({error, resetErrorBoundary}) => (
              <div>
                <Alert
                  message="Sorry, google auth is not available at the moment"
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              </div>
            )}
          >
            <GoogleOAuthButton type="login" />
          </ErrorBoundary>
        </div>
      </StyledAuthTitleCenterAlign>
    </AuthFormWrapper>
  );
};

export default LoginPage;
